import type { UserSummary } from '../api/types';
import { hasAnyTag, tagsOf } from './tags';

export interface ListFilters {
  filter: string;
  search: string;
  tagFilter: string[];
}

export function compareUserNames(a: string, b: string): number {
  const left = a.toUpperCase();
  const right = b.toUpperCase();
  return left < right ? -1 : left > right ? 1 : 0;
}

export function mergeUser(users: UserSummary[], user: UserSummary): UserSummary[] {
  return [...users.filter((existing) => existing.id !== user.id), user].sort((a, b) =>
    compareUserNames(a.name, b.name),
  );
}

export function matchesQuery(user: UserSummary, query: string): boolean {
  const needle = query.trim().toLowerCase();
  if (!needle) return true;
  return (
    user.name.toLowerCase().includes(needle) ||
    (user.email ?? '').toLowerCase().includes(needle) ||
    user.username.toLowerCase().includes(needle)
  );
}

export function revealFilters(
  user: UserSummary,
  current: ListFilters,
  knownFilters: string[],
): ListFilters {
  const filter =
    current.filter === 'All' || current.filter === user.status
      ? current.filter
      : knownFilters.includes(user.status)
        ? user.status
        : 'All';
  const search = matchesQuery(user, current.search) ? current.search : '';
  const tagFilter = hasAnyTag(tagsOf(user), current.tagFilter) ? current.tagFilter : [];
  return { filter, search, tagFilter };
}

export function createdToast(base: string, user: UserSummary): string {
  return user.status === 'Pending' ? `${base} · Pending until first sign-in` : base;
}
